pds-modal-header {
  display: block;
  width: 100%;
}

.pds-modal__header {
  width: 100%;
}
